import axios from './axios.service';
import config from './../config';
import { getQueryStringFromObject, getRequestHeaders } from './common.service';

let cancelGetFilesTokenSource;
async function getFiles(query=null) {

    if (cancelGetFilesTokenSource) {
        cancelGetFilesTokenSource.cancel('Operation canceled due to new request.');
    }
    cancelGetFilesTokenSource = axios.CancelToken.source();

    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.SERVER_BASE_URL + '/files' + queryString, {
                headers: headers,
                cancelToken: cancelGetFilesTokenSource.token
            });
        } catch (error) {

            console.log('error', error);
            if (axios.isCancel(error)) {
                return;
            }

            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}

let cancelGetFilesContainersTokenSource;
async function getFilesContainers(query=null) {
    
    if (cancelGetFilesContainersTokenSource) {
        cancelGetFilesContainersTokenSource.cancel('Operation canceled due to new request.');
    }
    cancelGetFilesContainersTokenSource = axios.CancelToken.source();

    try {
        let queryString = '';
        if (query) {
            queryString = '?' + getQueryStringFromObject(query);
        }
        let response;
        try {
            let headers = getRequestHeaders();
            response = await axios.get( config.SERVER_BASE_URL + '/files/containers' + queryString, {
                headers: headers,
                cancelToken: cancelGetFilesContainersTokenSource.token
            });
        } catch (error) {

            console.log('error', error);
            if (axios.isCancel(error)) {
                return;
            }

            return error.response.data;
        }
        return response.data;
    } catch (error) {
        return { error: error.message };
    }
}


async function getFile(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/files/' + fileId, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function getFileAuditLogs(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/files/' + fileId + '/audit_logs', { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function getFileSharedUsers(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/files/' + fileId + '/shared_users', { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function updateFile(fileId, payload) {
  let response;
  try {
      let headers = getRequestHeaders();
      response = await axios.patch( config.SERVER_BASE_URL + '/files/' + fileId, payload, { headers: headers });
  } catch (error) {
      return error.response.data;
  }
  return response.data;
}

async function addFile(payload) {
  let response;
  try {
      let headers = getRequestHeaders();
      response = await axios.post( config.SERVER_BASE_URL + '/files', payload, { headers: headers });
  } catch (error) {
      return error.response.data;
  }
  return response.data;
}

async function createOfficeFile(payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/files/office/create', payload, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function uploadFiles(formData) {
    let response;
    try {
        let headers = getRequestHeaders(true);
        response = await axios.post( config.SERVER_BASE_URL + '/files/upload', formData, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function generateLabels(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/files/' + fileId + '/generate_labels', {}, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function updateLabelsToMultipleFiles(payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/files/labels', payload, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function updateFlagsToMultipleFiles(payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/files/flags', payload, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function updateContainersToMultipleFiles(payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/files/containers', payload, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function deleteFile(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.delete( config.SERVER_BASE_URL + '/files/' + fileId, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function deleteMultipleFiles(payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.delete( config.SERVER_BASE_URL + '/files', {
            headers: headers,
            data: payload
        });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function duplicateFile(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.post( config.SERVER_BASE_URL + '/files/' + fileId + '/duplicate', {}, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function getOrganizingStatus() {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/files/organizing/status', { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function getFileWorkflows(fileId) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.get( config.SERVER_BASE_URL + '/files/' + fileId + '/workflows', { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

async function updateFileWorkflows(fileId, payload) {
    let response;
    try {
        let headers = getRequestHeaders();
        response = await axios.put( config.SERVER_BASE_URL + '/files/' + fileId + '/workflows', payload, { headers: headers });
    } catch (error) {
        return error.response.data;
    }
    return response.data;
}

export {
    addFile,
    getFiles,
    getFilesContainers,
    createOfficeFile,
    uploadFiles,
    getFile,
    getFileAuditLogs,
    getFileSharedUsers,
    updateFile,
    generateLabels,
    updateLabelsToMultipleFiles,
    updateFlagsToMultipleFiles,
    updateContainersToMultipleFiles,
    deleteFile,
    deleteMultipleFiles,
    duplicateFile,
    getOrganizingStatus,
    getFileWorkflows,
    updateFileWorkflows,
}
